import { IAccountInfo } from "services/api/types";

export const getAccountString = (account: IAccountInfo) => {
  return `${account.name} (${account.identifier})`;
};
